import { useState, useEffect } from "react";

export default function useFetch({
  api,
  method,
  url,
  data = null,
  config = null,
}) {
  const [response, setResponse] = useState(null);
  const [isError, setIsError] = useState("");
  const [isLoading, setIsLoading] = useState(true);
//const [status, setStatus] = useState('');
  useEffect(() => {
    const fetchData = async () => {
      try {
        api[method](url, JSON.parse(config), JSON.parse(data))
          .then((res) => {
            setResponse(res.data);
          })
          .finally(() => {
            setIsLoading(false);
          });
      } catch (err) {
        console.error(err.response.status);
        setIsError(err);
      }
    };

    fetchData();
  }, [api, method, url, data, config]);

  return { response, isError, isLoading };
}
